var map = {
	"./icon-label-bestseller.svg": 1313,
	"./icon-label-free.svg": 1314,
	"./icon-label-new.svg": 1315,
	"./icon-label-popular.svg": 1316,
	"./icon-label-top-rated.svg": 1317,
	"./icon-label-trending.svg": 1318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;